import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SymptomChipTitle from '@components/SymptomChipTitle';
import { useStyles } from './styles';

function CardHeaderChips({ symptomChipsList }) {
  const classes = useStyles();
  const { t } = useTranslation('checkCovidScreen');

  return (
    <>
      <Typography className={classes.cardQuestion}>
        {t('questions.complaints')}
      </Typography>
      <Box className={classes.chipsContainer}>
        {symptomChipsList.map(chip => {
          return (
            <SymptomChipTitle
              key={chip.id}
              srcImg={chip.srcImg}
              title={chip.title}
            />
          );
        })}
      </Box>
    </>
  );
}

export default CardHeaderChips;
